import { Navigate, generatePath } from 'react-router-dom';

import { NBA_PLAY_CHASE_EVENTTYPE_FIXTURE } from '@sorare/core/src/constants/__generated__/routes';
import { useLastVisitedEventType } from '@sorare/core/src/hooks/useLastVisitedEventType';

const ChasePage = () => {
  const defaultFixture = 'ongoing';
  const { lastVisitedEventType } = useLastVisitedEventType();

  return (
    <Navigate
      to={generatePath(NBA_PLAY_CHASE_EVENTTYPE_FIXTURE, {
        eventType: lastVisitedEventType,
        fixture: defaultFixture,
      })}
      replace
    />
  );
};

export default ChasePage;
